import React from 'react';
import Tooltip from '@src/components/Tooltip';
import BadgeAvatar from '@src/components/BadgeAvatar';
import Typography from '@src/new-components/Typography';
import LimitedFeature from '@src/components/LimitedFeature';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { convertFormatDate } from '@src/utils/date';
import RunningWithErrorsRoundedIcon from '@mui/icons-material/RunningWithErrorsRounded';
import CommonButton from '@src/new-components/Button';
import { StyledSpeakerOption } from './index.style';

const SpeakerOption = ({
  handleOpenVoices,
  isSynthesizing,
  voice,
  speakerName,
  isInValidPublicVoiceCloning,
  openVoice,
  isVoiceCloningAboutToRemoved,
}) => {
  const { t } = useTranslation();
  const renderArrow = (anchorDropdown) => {
    if (anchorDropdown) {
      return (
        <ArrowDropUpRoundedIcon
          sx={{ color: COLOR.navyBlue, fontSize: '24px' }}
        />
      );
    }
    return (
      <ArrowDropDownRoundedIcon
        sx={{ color: COLOR.navyBlue, fontSize: '24px' }}
      />
    );
  };
  return (
    <StyledSpeakerOption>
      <Tooltip arrow title={t('chooseSpeaker')} placement="top">
        <CommonButton
          onClick={handleOpenVoices}
          data-id="open-voice-list"
          disabled={isSynthesizing}
          variant="transparent"
          customStyle={{
            border: 'none',
            padding: '4px 6px',
            borderRadius: '16px',
            '&:hover': {
              background: COLOR.secondary[80],
              border: 'none!important',
            },
            '&:focus': {
              background: COLOR.secondary[80],
            },
          }}
        >
          <BadgeAvatar
            width={25}
            smallImgWidth={10}
            img={voice?.roundImage}
            smallImg={voice?.language?.roundImage}
            type="image"
          />
          <Typography
            variant="body2"
            className={
              isInValidPublicVoiceCloning ? 'invalid-voice-name' : 'voice-name'
            }
          >
            {speakerName}
          </Typography>
          {renderArrow(openVoice)}
        </CommonButton>
      </Tooltip>
      <LimitedFeature voiceFeatures={voice?.features} />
      {isVoiceCloningAboutToRemoved && (
        <Tooltip
          arrow
          title={t('voiceCloningDiscardAt', {
            date: convertFormatDate(voice?.discardAt),
          })}
          placement="top"
        >
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
      {isInValidPublicVoiceCloning && (
        <Tooltip arrow title={t('invalidPublicVoiceCloning')} placement="top">
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
    </StyledSpeakerOption>
  );
};

export default SpeakerOption;
